export const SELECT_CHART_TYPE_REQ = 'SELECT_CHART_TYPE_REQ'
export const SELECT_CHART_TYPE_SUCC = 'SELECT_CHART_TYPE_SUCC'
export const SELECT_CHART_TYPE_FAIL = 'SELECT_CHART_TYPE_FAIL'


export const SELECT_SUBCHART_TYPE_REQ = "SELECT_SUBCHART_TYPE_REQ"
export const SELECT_SUBCHART_TYPE_SUCC = "SELECT_SUBCHART_TYPE_SUCC"
export const SELECT_SUBCHART_TYPE_FAIL = "SELECT_SUBCHART_TYPE_FAIL"
export const DESELECT_SUBCHART_TYPE = "DESELECT_SUBCHART_TYPE"